module.exports = __webpack_public_path__ + "img/sample-provider-logo.6b56cf2e.png";